let GeojsonBuilder = function () {
  'ngInject'

  return {
    getGeojson: getGeojson,
  }

  function getGeojson (geojsonArry) {
    let geoJson = {
      'type': 'FeatureCollection',
      'features': [
        {
          'type': 'Feature',
          'properties': {},
          'geometry': {
            'type': 'MultiLineString',
            'coordinates': [
              [],
            ],
          },
        },
      ],
    }
    geoJson.features[0].geometry.coordinates[0] = geojsonArry;
    return geoJson;


  }
}
export default GeojsonBuilder



// WEBPACK FOOTER //
// ./client/app/services/geojsonBuilder/geojsonBuilder.service.js